import React from 'react';
import ActionButton from '@/common/components/buttons/ActionButton';
import ListTable from '../../../common/components/ListTable';
import Loading from '../../../common/components/Loading';
import InstantFormsEdit from './components/InstantFormsEdit';
import { columnList, INIT_VALUES } from './constants/index.js';
import { ShowArrow, Wrapper, TableTitle, QueueTableWrapper } from './InstantForms.styles';
import { useInstantForms } from './hooks/useInstantForms';



const InstantForms = () => {

	const {
		isLoading,
		isActiveDisplayed, setIsActiveDisplayed,
		isUnactiveDisplayed, setIsUnactiveDisplayed,
		forms,
		showNew, setShowNew,
	} = useInstantForms();

	return (
		<>
			{isLoading && <Loading />}
			<Wrapper>
				<ActionButton
					style={{ width: 'fit-content' }}
					onClick={() => {
						setShowNew(INIT_VALUES)
					}}
					defaultText='Create instant form'
				/>

				<TableTitle onClick={() => setIsActiveDisplayed((prev) => !prev)}>
					Active Instant Forms{' '}
					<ShowArrow show={isActiveDisplayed} />
				</TableTitle>
				<QueueTableWrapper show={isActiveDisplayed}>
					<ListTable
						column={columnList}
						row={forms.active}
						entityName={'instant-forms'}
						editItemWidth={50}
						actions={{
							onDuplicate: (form) => setShowNew({ ...form.rest, _id: undefined }),
							onEdit: (form) => setShowNew(form.rest),
						}}
					/>
				</QueueTableWrapper>
				<TableTitle onClick={() => setIsUnactiveDisplayed((prev) => !prev)}>
					Unactive Instant Forms{' '}
					<ShowArrow show={isUnactiveDisplayed} />
				</TableTitle>
				<QueueTableWrapper show={isUnactiveDisplayed}>
					<ListTable
						column={columnList}
						row={forms.unactive}
						entityName={'instant-forms'}
						editItemWidth={50}
						actions={{
							onDuplicate: (form) => setShowNew({ ...form.rest, _id: undefined }),
							onEdit: (form) => setShowNew(form.rest),
						}}
					/>
				</QueueTableWrapper>
				{showNew && (
					<InstantFormsEdit
						edit={showNew}
						setShow={() => setShowNew(null)}
					/>
				)}
			</Wrapper >
		</>

	);
};

export default InstantForms;
